import { render, staticRenderFns } from "./ImageInfoMaskPreview.vue?vue&type=template&id=42f48516&scoped=true"
import script from "./ImageInfoMaskPreview.vue?vue&type=script&lang=ts"
export * from "./ImageInfoMaskPreview.vue?vue&type=script&lang=ts"
import style0 from "./ImageInfoMaskPreview.vue?vue&type=style&index=0&id=42f48516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f48516",
  null
  
)

export default component.exports